import { HttpEventType, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import * as FileSaver from 'file-saver';
import _ from 'lodash';
import * as moment from 'moment';
import { of, Subject, Subscription, throwError } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment.local';
import { Helpers } from '../../../helpers';
import { DocumentSource } from '../../../_shared/enums/documentSource.enum';
import { FilePreviewType } from '../../../_shared/enums/filePreviewType.enum';
import { HelperService } from '../../../_shared/services/helper.service';
import { MfToastService } from '../../../_shared/services/mfToast.service';
import { StorageService } from '../../../_shared/services/storage.service';
import { TermsService } from '../../pages/home/_services';
import { ConfigGUIService } from '../../pages/home/_services/configGUI.service';
import { DocumentsService } from '../../pages/home/_services/documents.service';
import { FileSource } from '../../pages/telemedicine/enums/file-source.enum';
import { DocumentData } from '../../pages/telemedicine/model/document-data.model';
import { WebSocketChat } from '../../pages/telemedicine/model/web-socket-chat.model';
import { TelemedicineService } from '../../pages/telemedicine/telemedicine.service';
import { Document, DocumentViewerDocument } from './../../../_shared/model/document.model';
import { ShareDocument } from './../../../_shared/model/utils/share-document.model';
import { BaseState } from './../../../_shared/state/base/base.state';
import { DocumentViewerType } from './document-viewer-type.enum';
import { DocumentViewerService } from './document-viewer.service';

@Component({
    selector: 'document-viewer',
    templateUrl: './document-viewer.component.html',
    styles: [],
})
export class DocumentViewerComponent implements OnInit, OnDestroy {
    constructor(
        public fb: FormBuilder,
        public helper: HelperService,
        public mfToast: MfToastService,
        public docviewRest: DocumentsService,
        public termsService: TermsService,
        public storage: StorageService,
        public configGUIRest: ConfigGUIService,
        public wscs: TelemedicineService,
        public dvs: DocumentViewerService,
        public store: Store,
    ) {}

    @Input()
    set setData(data: DocumentViewerDocument[]) {
        if (!_.isNil(data)) {
            this.numberOfElements = data.length;
            this.allDocuments = _.cloneDeep(data);
            this.allDocumentsClone = _.cloneDeep(data);
        }
    }

    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public termData: any;

    @Input()
    shareDocumentData: ShareDocument;
    private contractorId: number = this.store.selectSnapshot(BaseState.activeContractorId);

    public allDocuments: DocumentViewerDocument[];
    public allDocumentsClone: DocumentViewerDocument[];
    public isMenuDropdownOpen = false;
    public documentsForm: FormGroup;
    public reservationDocuments$Sub: Subscription;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public eventStream: Subject<any>;
    public percentDone = 0;
    public selectedFilesForUpload: FileList;
    public isVisibleInput = false;
    public thumbnailSelection = false;
    public customerDocumentViewType: FilePreviewType = FilePreviewType.LIST; //list,large,small
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public inputData: any = {
        thumbnailMode: false,
        customerDocumentViewType: FilePreviewType.LIST,
    };
    //pagenacija
    public currentPage = 1;
    public selectedDay = true;
    public itemsPerPage = 6;
    public numberOfElements = 0;
    private onDestroy$ = new Subject<void>();
    public dvType = DocumentViewerType;

    ngOnInit() {
        this.configGUIRest
            .getUserContractorGuiSettings(this.contractorId)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(guiData => {
                this.customerDocumentViewType = _.get(guiData, 'app.customerDocumentViewType', FilePreviewType.LIST) as FilePreviewType;
                this.inputData = {
                    customerDocumentViewType: this.customerDocumentViewType,
                    thumbnailMode:
                        this.customerDocumentViewType === FilePreviewType.SMALL || this.customerDocumentViewType === FilePreviewType.LARGE
                            ? true
                            : false,
                };
            });
        this.createForm();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public shareDocument(document: Document) {
        this.dvs
            .shareDocument(this.shareDocumentData)
            .pipe(
                takeUntil(this.onDestroy$),
                filter(receiver => receiver !== undefined),
                mergeMap(reciever =>
                    this.docviewRest
                        .shareDocument(this.contractorId, this.shareDocumentData.customerId, document.documentId, reciever)
                        .pipe(takeUntil(this.onDestroy$)),
                ),
            )
            .subscribe(
                () => {
                    document.shared = true;
                    this.mfToast.success('Datoteka uspešno deljena');
                },
                err => {
                    if (this.helper.checkStructError(err, 'shareCustomerData')) {
                        this.mfToast.warning('Datoteka je že bila deljena.');
                    }
                },
            );
    }

    public stopShareDocument(document: Document): void {
        this.docviewRest
            .unshareDocument(this.contractorId, this.shareDocumentData.customerId, document.documentId)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(
                () => {
                    document.shared = false;
                    this.mfToast.success('Preklic deljenja dokumenta uspešen');
                },
                () => this.mfToast.error('Napaka pri preklicu deljenja dokumenta'),
            );
    }

    public createForm(): void {
        this.documentsForm = this.fb.group({
            uploadFile: [''],
            comment: [''],
        });
    }

    public selectFile($event): void {
        this.selectedFilesForUpload = $event.target.files;
    }

    public onSubmitAddDocument(): void {
        this.uploadFile(this.selectedFilesForUpload);
    }
    public downloadDocument(doc: Document): void {
        this.docviewRest
            .openDocument(this.contractorId, doc.documentId)
            .pipe(
                takeUntil(this.onDestroy$),
                map(res => {
                    if (res.type !== 0) {
                        return new Blob([res.body], { type: res.body.type });
                    }
                }),
            )
            .subscribe(res => {
                if (res) {
                    FileSaver.saveAs(res, doc.description);
                }
            });
    }

    public changeView() {
        switch (this.customerDocumentViewType) {
            case FilePreviewType.LIST:
                this.customerDocumentViewType = FilePreviewType.SMALL;
                break;
            case FilePreviewType.SMALL:
                this.customerDocumentViewType = FilePreviewType.LARGE;
                break;
            case FilePreviewType.LARGE:
                this.customerDocumentViewType = FilePreviewType.LIST;
                break;
        }
        this.inputData = {
            thumbnailMode:
                this.customerDocumentViewType === FilePreviewType.SMALL || this.customerDocumentViewType === FilePreviewType.LARGE ? true : false,
            customerDocumentViewType: this.customerDocumentViewType,
        };
        this.configGUIRest
            .getUserContractorGuiSettings(this.contractorId)
            .pipe(
                takeUntil(this.onDestroy$),
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                map((guiData: any) => {
                    guiData.app.customerDocumentViewType = this.customerDocumentViewType;
                    return guiData;
                }),
            )
            .subscribe(el => {
                this.configGUIRest.updateUserContractorGuiSettings(this.contractorId, el);
            });
    }

    public openMediaViewDialog(doc: Document) {
        this.docviewRest
            .openDocument(this.contractorId, doc.documentId)
            .pipe(
                tap(() => {
                    Helpers.setLoading(true);
                }),
                map(res => {
                    if (res.type !== 0) {
                        return new Blob([res.body], { type: res.body.type });
                    }
                }),
            )
            .subscribe(
                res => {
                    if (res) {
                        Helpers.setLoading(false);

                        this.helper.openDocumentViewer(res, res.type, doc.description, undefined, true).subscribe(el => {
                            //index elementa
                            const documents = this.allDocuments;
                            let index = 0;
                            documents.forEach((el, ind) => {
                                if (JSON.stringify(el) === JSON.stringify(doc)) {
                                    index = ind;
                                }
                            });
                            //index +1/-1
                            index = el === 'next' ? index + 1 : index - 1;
                            index = index === documents.length ? 0 : index;
                            index = index < 0 ? documents.length - 1 : index;
                            //daj nov element v openMediaViewDialog funkcijo
                            this.openMediaViewDialog(documents[index]);
                        });
                    }
                },
                () => {
                    this.mfToast.errorAndSend('Napaka pri odpiranju dokumenta.');
                },
            );
    }

    public removeDocumetFromlist(doc: Document): void {
        this.helper.displayAlert('Brisanje dokumenta.', 'Izbrišem izbrani dokument?').then(result => {
            if (result.value) {
                switch (this.shareDocumentData.type) {
                    case this.dvType.CUSTOMER:
                        this.docviewRest
                            .deleteCustomerDocument(this.contractorId, this.storage.getSelectedCustomerId(), doc.documentId)
                            .pipe(
                                takeUntil(this.onDestroy$),
                                catchError(err => {
                                    this.mfToast.errorAndSend('Napaka pri brisanju datoteke');
                                    console.error('napaka pri brisanju datoteke');
                                    return throwError(() => err);
                                }),
                            )
                            .subscribe(() => {
                                this.mfToast.success('Datoteka uspešno izbrisana.');
                                this.numberOfElements--;
                                this.allDocuments = this.allDocuments.filter(el => el.documentId != doc.documentId);
                            });
                        break;
                    case this.dvType.TERM:
                        if (doc.isMedicalRecordDocument) {
                            this.termsService
                                .deleteMedicalRecordDocument(this.termData.prereservationId, this.storage.getSelectedContractor()?.id, doc.documentId)
                                .pipe(
                                    catchError(err => {
                                        if (err.status === HttpStatusCode.Ok) {
                                            return of(true);
                                        }
                                        console.error('napaka pri brisanju datoteke');
                                        return throwError(() => err);
                                    }),
                                )
                                .subscribe(() => {
                                    this.mfToast.success('Datoteka uspešno izbrisana.');
                                    this.numberOfElements--;
                                    this.allDocuments = this.allDocuments.filter(el => el.documentId != doc.documentId);
                                });
                            break;
                        }

                        this.docviewRest
                            .deleteDocumentVR(this.shareDocumentData.prereservationId, doc.documentId, this.shareDocumentData.visitId)
                            .pipe(
                                takeUntil(this.onDestroy$),
                                catchError(err => {
                                    this.mfToast.errorAndSend('Napaka pri brisanju datoteke');
                                    console.error('napaka pri brisanju datoteke');
                                    return throwError(() => err);
                                }),
                            )
                            .subscribe(() => {
                                this.mfToast.success('Datoteka uspešno izbrisana.');
                                this.numberOfElements--;
                                this.allDocuments = this.allDocuments.filter(el => el.documentId != doc.documentId);
                            });
                        break;
                    case this.dvType.TREATMENT:
                        //TODO
                        break;
                }
            }
        });
    }

    public filter(showAll: boolean) {
        if (!showAll) {
            this.currentPage = 1;
        }

        let numOfItems = 0;
        if (!showAll) {
            this.allDocuments = this.allDocuments.filter(el => {
                return el.contentType.includes('image');
            });
            numOfItems = this.allDocuments.length;
        } else {
            this.allDocuments = _.cloneDeep(this.allDocumentsClone);
            numOfItems = this.allDocuments.length;
        }
        //  this.allDocuments
        this.numberOfElements = numOfItems;
        return numOfItems;
        // this.numberOfElements = this.dataManager.filter(showAll);
        // this.allDocuments =  _.remove(this.allDocuments, (el)=> el.documentId == doc.documentId)
    }

    public addOrCancel() {
        this.isVisibleInput = !this.isVisibleInput;
        this.selectedFilesForUpload = undefined;
        this.documentsForm.reset();
    }

    private uploadFile(files: FileList): void {
        if (!files || files.length == 0) {
            this.mfToast.warning('Nobena datoteka ni izbrana.');
            return;
        }
        const file: File = files[0];
        if (file.size > environment.FILE_UPLOAD_MAX_SIZE) {
            this.mfToast.errorAndSend('Datoteka je prevelika. (Max: ' + environment.FILE_UPLOAD_MAX_SIZE / 1024 / 1024 + ' MB)');
            return;
        }
        if (!this.documentsForm.value.comment) {
            this.documentsForm.value.comment = file.name;
        }
        this.docviewRest.uploadFile(file, this.documentsForm.value.comment).subscribe(
            event => {
                if (event.type == HttpEventType.UploadProgress) {
                    this.percentDone = Math.round((100 * event.loaded) / event.total);
                    console.log(`File is ${this.percentDone}% loaded.`);
                } else if (event instanceof HttpResponse) {
                    console.log('File is completely loaded.');
                }
                if (event.type == HttpEventType.Response) {
                    switch (this.shareDocumentData.type) {
                        case this.dvType.TERM:
                            this.docviewRest
                                .addFileToVR(this.shareDocumentData.prereservationId, event.body, this.shareDocumentData.visitId)
                                .pipe(takeUntil(this.onDestroy$))
                                .subscribe(
                                    () => {
                                        this.mfToast.success('Datoteka uspešno naložena.');
                                        this.isVisibleInput = false;
                                        this.allDocuments.push(
                                            new DocumentViewerDocument().deserialize({
                                                description: this.documentsForm.value.comment,
                                                documentAdded: moment().toDate(),
                                                documentId: event.body,
                                                contentType: file.type,
                                            }),
                                        );
                                        this.numberOfElements = this.allDocuments?.length;
                                        this.documentsForm.reset();
                                        this.percentDone = 0;
                                    },
                                    error => {
                                        this.mfToast.errorAndSend('Težava pri nalaganju datoteke.');
                                        console.error(error);
                                        this.percentDone = 0;
                                    },
                                );
                            break;
                        case this.dvType.CUSTOMER:
                            this.docviewRest
                                .addFileToCustomer(this.contractorId, this.storage.getSelectedCustomerId(), event.body)
                                .pipe(takeUntil(this.onDestroy$))
                                .subscribe(
                                    () => {
                                        this.mfToast.success('Datoteka uspešno naložena.');
                                        this.isVisibleInput = false;
                                        this.numberOfElements++;
                                        const tmp = new DocumentViewerDocument().deserialize({
                                            description: this.documentsForm.value.comment,
                                            documentAdded: moment().toDate(),
                                            documentId: event.body,
                                            contentType: file.type,
                                            documentSource: DocumentSource.CUSTOMER,
                                        });
                                        this.allDocuments.push(tmp);
                                        // this.data.push(tmp);

                                        this.documentsForm.reset();
                                        this.percentDone = 0;
                                    },
                                    error => {
                                        this.mfToast.errorAndSend('Težava pri nalaganju datoteke.');
                                        console.error(error);
                                        this.percentDone = 0;
                                    },
                                );
                            break;
                        case this.dvType.TREATMENT:
                            this.docviewRest.addFileToTreatmenNote(this.contractorId, this.shareDocumentData?.trNoteId, event.body).subscribe(
                                () => {
                                    this.mfToast.success('Datoteka uspešno naložena.');
                                    this.isVisibleInput = false;
                                    const tmp = new DocumentViewerDocument().deserialize({
                                        description: this.documentsForm.value.comment,
                                        documentAdded: moment().toDate(),
                                        documentId: event.body,
                                        contentType: file.type,
                                        documentSource: DocumentSource.CUSTOMER,
                                    });
                                    this.allDocuments.push(tmp);
                                    // this.data.push(tmp);

                                    this.documentsForm.reset();
                                    this.percentDone = 0;
                                },
                                error => {
                                    this.mfToast.errorAndSend('Težava pri nalaganju datoteke.');
                                    console.error(error);
                                    this.percentDone = 0;
                                },
                            );
                            break;
                    }
                }
            },
            err => {
                if (err.status === 413) {
                    this.mfToast.errorAndSend('Datoteka je prevelika.');
                } else if (this.helper.checkStructError(err, 'VIRUS')) {
                    this.mfToast.error('Datoteka mogoče vsebuje zlonamerno kodo, nalaganje ni mogoče.');
                } else {
                    this.mfToast.error('Težava pri nalaganju datoteke.');
                }
                this.percentDone = 0;
            },
            () => {
                console.log('Upload done');
            },
        );
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public attachToHDChat(document: any) {
        let chatData = [];
        this.wscs
            .getChatData(this.termData.prereservationId)
            .pipe(
                takeUntil(this.onDestroy$),
                tap((chat: WebSocketChat[]) => {
                    if (chatData && chat) {
                        chatData.push(...(chat || []));
                    } else {
                        chatData = chat;
                    }
                }),
            )
            .subscribe(() => {
                const documentData = [
                    new DocumentData().deserialize({
                        documentId: document?.documentId,
                        description: null,
                        contentType: 'application/pdf',
                        fileName: document.description,
                    }),
                ];
                this.wscs.sendChatSocketOuterComponent(this.termData.prereservationId, '', documentData, FileSource.DOCUMENT);
            });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/ban-types
    styleMenu(type: 'menuIcon' | 'icon'): Object {
        if (window.innerWidth >= 1200 && window.innerWidth <= 1355) {
            if (type === 'menuIcon') {
                return { display: 'block' };
            } else {
                return { display: 'none' };
            }
        } else {
            if (type === 'menuIcon') {
                return { display: 'none' };
            } else {
                return { display: 'block' };
            }
        }
    }
}
